export default __webpack_public_path__ + "static/media/amediateka_head.9fcc11d0.svg";